module.exports = __webpack_public_path__ + "img/music.27645b9e.svg";